import { atom, useSetRecoilState, useRecoilValue } from 'recoil';

/**
 * A boolean state defining if the user is authenticated
 */
export const AuthState = {
  authenticating: 'authenticating',
  authenticated: 'authenticated',
};

const authenticationState = atom({
  key: 'authenticationState',
  default: AuthState.authenticating,
});

export const useAuthenticationState = () => useRecoilValue(authenticationState);

export const useSetAuthenticationState = () =>
  useSetRecoilState(authenticationState);
